import type { SupportContent } from "../types";

export const support: SupportContent = {
  meta: {
    title: "Support & Hilfe-Center | Flex Fund Prop Firm",
    description:
      "Hilfe von echten Menschen. E-Mail-Support und eine durchsuchbare FAQ-Wissensdatenbank — schnelle Antworten für Trader und Interessenten, rund um die Uhr.",
  },
  hero: {
    line1: "Echte Menschen.",
    line2Highlight: "Schnelle Antworten.",
    // [de-review] States the average first-reply time — a service promise.
    lede: "Schreib unserem Team eine E-Mail oder durchsuche die FAQ-Bibliothek. Erste Antwort im Schnitt unter vier Stunden.",
  },
  channels: {
    email: {
      name: "E-Mail",
      desc: "",
      cta: "E-Mail senden",
      // [de-review] A response-time commitment.
      meta: "ANTWORT IM SCHNITT < 4 Stunden",
    },
    helpCenter: {
      name: "Hilfe-Center",
      desc: "Durchsuchbare FAQ-Wissensdatenbank",
      cta: "FAQs öffnen",
      meta: "24/7 · SOFORTIGE ANTWORTEN",
    },
  },
  faqPanel: {
    titleLead: "Durchsuche die ",
    titleHighlight: "FAQ-Bibliothek",
    body: "Die meisten Antworten stehen in der Flex Fund Wissensdatenbank — Auszahlungen, Regeln, Konto, Plattform, Abrechnung.",
  },
  form: {
    heading: "Nachricht senden",
    namePlaceholder: "Dein Name",
    emailPlaceholder: "E-Mail",
    messagePlaceholder: "Beschreib uns, worum es geht…",
    submit: "Nachricht senden",
    sent: "E-Mail geöffnet ✓",
    topics: {
      account: "Konto",
      payouts: "Auszahlungen",
      rules: "Regeln",
      platform: "Plattform",
      billing: "Abrechnung",
    },
    footnote: "ÖFFNET DEIN E-MAIL-PROGRAMM · ANTWORT UNTER 4 STUNDEN · 24/7",
  },
  widget: {
    dialogLabel: "Eine Nachricht an den Support senden",
    openTrigger: "Support-Formular öffnen",
    closeTrigger: "Support-Formular schließen",
    closePanel: "Support-Formular schließen",
    heading: "Schreib uns eine Nachricht",
  },
};
